import { useCallback } from 'react';

import { useRemoveItemFromTemplate } from 'react-hooks';

import type { MutationContext } from './mutationLane';

export type HideQuestionInput = {
  channelId: string;
  templateId: string;
  itemId: string;
};

export type HideQuestion = (
  input: HideQuestionInput,
  context: MutationContext
) => Promise<number>;

// `context.baseVersion` is not sent yet: it is the hook point for the
// expected version (TS-55794)
export function useHideQuestion(): HideQuestion {
  const { removeItemFromTemplate } = useRemoveItemFromTemplate();

  return useCallback<HideQuestion>(
    async input => {
      const { newVersion } = await removeItemFromTemplate(input);

      return newVersion;
    },
    [removeItemFromTemplate]
  );
}
